import { render, staticRenderFns } from "./vehicleCargoOp.vue?vue&type=template&id=c88169ae&scoped=true&"
import script from "./vehicleCargoOp.vue?vue&type=script&lang=js&"
export * from "./vehicleCargoOp.vue?vue&type=script&lang=js&"
import style0 from "./vehicleCargoOp.vue?vue&type=style&index=0&id=c88169ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88169ae",
  null
  
)

export default component.exports